import { ComparativeContent } from '../content';
import { ComparativeModalContainer } from './styles';

export interface MunicipalityComparativeModal {
  id?: string;
  name?: string;
}

interface ComparativeModalProps {
  municipalityData: MunicipalityComparativeModal;
  open: boolean;
  onClose: () => void;
  onGetMunicipalitiesComparative: (municipalities: MunicipalityComparativeModal[]) => void;
  savedSelections?: MunicipalityComparativeModal[];
  limit?: number;
}

export const ComparativeModal = ({
  municipalityData,
  open,
  onClose,
  onGetMunicipalitiesComparative,
  savedSelections = [],
  limit,
}: ComparativeModalProps) => {
  return (
    <ComparativeModalContainer open={open} onClose={onClose}>
      <ComparativeContent
        municipalityData={municipalityData}
        open={open}
        onClose={onClose}
        onGetMunicipalitiesComparative={onGetMunicipalitiesComparative}
        savedSelections={savedSelections}
        limit={limit}
      />
    </ComparativeModalContainer>
  );
};
